export const abtastyScript = `
  (function (i, s, o, g, r, a, m) {
    i["abtiming"] = 1 * new Date();
    a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
  })(window, document, "script", "//try.abtasty.com/55aebc57d2e61286da5919aa21629cd4.js");
`;
